import React, { useContext, useEffect, useState } from "react";
import Context from "../../Context/Context";
import { useNavigate } from "react-router-dom";
import axios from "../axios/axios";
import MetasAvaliacao from "./MetasAvaliacao";
import * as pdfMake from "pdfmake/build/pdfmake";
import * as pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.vfs;

const meses = {
  0: "Janeiro",
  1: "Fevereiro",
  2: "Março",
  3: "Abril",
  4: "Maio",
  5: "Junho",
  6: "Julho",
  7: "Agosto",
  8: "Setembro",
  9: "Outubro",
  10: "Novembro",
  11: "Dezembro",
};

function MetasAvaliacaoControle() {
  const { usuario } = useContext(Context);
  const [registros, setRegistros] = useState(null);
  const nav = useNavigate();
  const [name, setName] = useState("");
  const [isControlComp, setIsControlComp] = useState(false);
  const [registrosMensais, setRegistrosMensais] = useState(null);
  const [ano, setAno] = useState("");
  const [mes, setMes] = useState("");

  const getRegistros = async () => {
    const { data } = await axios.get("/avaliacao/metas");
    // console.log(data)
    setRegistros(data);
  };

  const getRegistrosMensais = async () => {
    const { data } = await axios.get("/avaliacao/metas/mensais");
    setRegistrosMensais(data);
  };

  useEffect(() => {
    if (!usuario.role == "SupervisorNegocios") nav(-1);
    getRegistros();
  }, []);

  useEffect(() => {
    if (isControlComp && !registrosMensais) {
      getRegistrosMensais();
    }
  }, [isControlComp]);

  const gerarPDFComTabela = (registros) => {
    const formatedData = registros.map(
      ({ usuario, ano, total, total_entregues, mes }) => [
        usuario.nome,
        total,
        total_entregues,
        `${((total_entregues / total) * 100).toString().slice(0, 4)}%`,
        mes,
        ano,
      ],
    );
    const docDefinition = {
      content: [
        {
          text: "Relatório de Metas dos Usuários de Avaliação",
          style: "header",
        },
        {
          table: {
            headerRows: 1,
            widths: "******".split(""),
            body: [
              [
                "Nome",
                "N° Solicitações",
                "Realizadas",
                "Porcentagem",
                "Mês",
                "Ano",
              ],
              ...formatedData,
            ],
          },
          layout: {
            fillColor: (rowIndex) => (rowIndex === 0 ? "#D3D3D3" : null),
          },
        },
      ],
      styles: {
        header: {
          fontSize: 18,
          bold: true,
          margin: [0, 0, 0, 10],
        },
        tableHeader: {
          bold: true,
          fontSize: 13,
          alignment: "center",
        },
      },
      defaultStyle: {
        fontSize: 12,
      },
    };
    pdfMake.createPdf(docDefinition).download("registros.pdf");
  };

  return (
    <div className="flex flex-col justify-center w-full items-center mt-5 gap-5">
      <h2 className="text-black text-3xl font-semibold">Controle de Metas</h2>
      <div className="flex gap-5 my-5">
        <button
          className={`${!isControlComp && " bg-slate-800 text-white"} p-2 font-bold hover:bg-gray-700 hover:text-white`}
          onClick={() => setIsControlComp(false)}
        >
          Reátorio Mensal
        </button>
        <button
          className={`${isControlComp && " bg-slate-800 text-white"} hover:bg-gray-700 hover:text-white p-2 font-bold`}
          onClick={() => setIsControlComp(true)}
        >
          Ver relátorios de outros meses
        </button>
      </div>

      {!isControlComp ? (
        <>
          <div className="bg-slate-800 px-8 py-4 text-center rounded-lg text-white flex flex-col">
            <div className="flex gap-5">
              <p className="text-xl">
                Total de solicitações:{" "}
                <span className="">{registros?.somaTotal}</span>
              </p>
              <p className="text-xl">
                Total de solicitações entregues:{" "}
                <span className="">{registros?.somaEntregues}</span>
              </p>
              <p className="text-xl">
                Desempenho:{" "}
                <span className="">
                  {registros?.porcentagem?.toString().slice(0, 4)}%
                </span>
              </p>
            </div>
            <div className="w-full bg-gray-200 rounded-full h-2 dark:bg-gray-700 mt-4 ">
              <div
                className="bg-gray-500 h-2 rounded-full transition-all duration-300"
                style={{ width: `${registros?.porcentagem}%` }}
              ></div>
            </div>
          </div>

          <input
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="w-[30%] mt-10 border-gray-300 border-b-8 outline-none focus:none focus:border-gray-700"
            type="text"
          />

          <div className="mt-20 flex flex-wrap w-[90%] gap-10 justify-evenly mb-10">
            {registros?.registros
              ?.filter(({ usuario }) => {
                return usuario.nome.includes(name);
              })
              ?.map((meta) => (
                <MetasAvaliacao
                  key={meta.usuario.id}
                  metas={meta}
                  user={meta.usuario}
                />
              ))}{" "}
            {/* Sempre adicionar a key de cada registro, deve ser diferente um dos outros como um id, pois dois registros com a mesma key, atrapaham na sincronização de estado do react, e acabam sendo renderizados errado, por exemplo o registro 1 é renderizado no lugar do registro2 */}
          </div>
        </>
      ) : (
        <div>
          {/* {JSON.stringify(registrosMensais)} */}
          <div className="flex gap-5 w-[50%] m-auto mt-8">
            <select
              value={mes}
              onChange={(e) => setMes(e.target.value)}
              name=""
              id=""
            >
              <option key={"-1"} value="">
                Selecione um mês
              </option>
              {Object.keys(meses).map((e) => (
                <option key={e} value={e}>
                  {meses[e]}
                </option>
              ))}
            </select>

            <select
              value={ano}
              onChange={(e) => setAno(e.target.value)}
              name=""
              id=""
            >
              <option key="-2" value="">
                Selecione o Ano
              </option>
              <option value="2025">2025</option>
            </select>
          </div>
          <div className="flex gap-10 flex-wrap mt-16 w-full">
            {console.log(ano + mes)}
            {Object.keys(registrosMensais || {})
              ?.filter((e) => (ano && mes ? e == mes + ano : true))
              ?.map((e) => (
                <div
                  className="flex flex-col gap-5 items-center  rounded-md "
                  key={e}
                >
                  <div className="flex justify-between w-full">
                    <h2 className="text-black text-xl">
                      {meses[registrosMensais[e][0]?.mes]} de{" "}
                      {registrosMensais[e][0]?.ano}
                    </h2>

                    <button
                      onClick={() => gerarPDFComTabela(registrosMensais[e])}
                      className="bg-slate-800 text-white w-[30%] hover:bg-gray-600"
                    >
                      Gerar Pdf
                    </button>
                  </div>

                  <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
                    <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
                      <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                        <tr className="bg-gray-100 text-gray-700 text-md">
                          <th className="py-3 px-4 bg-slate-800">Usuário</th>
                          <th className="py-3 px-4 bg-slate-800">
                            N° Solicitações
                          </th>
                          <th className="py-3 px-4 bg-slate-800">Realizadas</th>
                        </tr>
                      </thead>
                      <tbody className="text-center border-t-2 border-gray-300">
                        {registrosMensais[e].map((el) => (
                          <tr key={el.id} className="hover:bg-gray-50 text-lg">
                            <td className="py-3 px-4">{el.usuario.nome}</td>
                            <td className="py-3 px-4">{el.total}</td>
                            <td className="py-3 px-4">{el.total_entregues}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              ))}
          </div>
        </div>
      )}
    </div>
  );
}

export default MetasAvaliacaoControle;
